import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { CompanyService } from '@features/contacts/services/company.service';
import { ContactService } from '@features/contacts/services/contact.service';

import { CompanyDetailsComponent, Content } from '../company-details.component';

@Component({
  selector: 'spark-contacts-company-edit',
  templateUrl: '../company-details.component.html'
})
export class CompanyEditComponent
  extends CompanyDetailsComponent
  implements OnInit
{
  readonly isNewEntity = false;

  get title(): string {
    return 'Edit Company';
  }

  get saveLabel(): string {
    return 'Save';
  }

  constructor(
    companyService: CompanyService,
    private contactService: ContactService
  ) {
    super(companyService);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  content(): Observable<Content> {
    return this.companyService.getCompanyForDisplay(this.companyId).pipe(
      switchMap((company) => {
        let contactIds: string[] = [
          ...(company.directors || []),
          ...(company.shareholders || []).map((s) => s.id)
        ];

        return this.contactService.getSpecificContacts(contactIds).pipe(
          map((contacts) => ({
            company,
            contacts
          }))
        );
      })
    );
  }
}
